<template>
<div class="content">
  <section class="content-file-browser">
    <ExtDocBrowser :hasUse="hasCallback" @doUse="callCallback" />
  </section>
</div>
</template>

<script>
export default {
  data: ()=>({
    parent: null,
  }),
  props: [
    "params", "index", "active"
  ],
  computed: {
    currentClient() {
      return this.stores.auth.currentClient;
    },
    hasCallback() {
      return !!this.stores.callbacks.lastCallback;
    },
  },
  methods: {
  },
  created() {
    var title="Spoljni dokumenti";
    this.stores.page.pushPage(title, this.params.path, this.index);
  },
  unmounted() {
    this.stores.page.popPage();
  },

}
</script>
